export default "__VITE_ASSET__m3XIDNAP__"